import React, { Component } from "react";
import "./post.css";
import VoteButton from "../../Components/VoteButton";

class Post extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabledUpvote: false,
      disabledDownvote: false,
      vote: 0,
      original_vote: 0,
    };
  }
  handleUpvoteClicked() {
    if (this.state.disabledDownvote) {
      this.setState({
        disabledDownvote: false,
      });
    } else {
      this.setState({
        disabledUpvote: true,
      });
      this.props.onPointChange(
        this.props.post.Author,
        this.props.post.Points + 1
      );
    }
  }
  handleDownvoteClicked() {
    if (this.state.disabledUpvote) {
      this.setState({
        disabledUpvote: false,
      });
    } else {
      this.setState({
        disabledDownvote: true,
      });
      this.props.onPointChange(
        this.props.post.Author,
        this.props.post.Points - 1
      );
    }
  }
  render() {
    return (
      <div className="post-container">
        <div className="secondaryContainer">
          <VoteButton
            disabled={this.state.disabledUpvote}
            onClick={this.handleUpvoteClicked.bind(this)}
          >
            Upvote
          </VoteButton>
          <VoteButton
            disabled={this.state.disabledDownvote}
            onClick={this.handleDownvoteClicked.bind(this)}
          >
            {" "}
            Downvote{" "}
          </VoteButton>
        </div>
      </div>
    );
  }
}
export default Post;
